import { call, options, params } from './helpers';

export const getContracts = (payload) =>
	call(`/beta/contracts${params(payload)}`);

export const addContract = (payload) =>
	call(`/beta/contracts`, options(payload, 'POST'));

export const getContract = ({ id }) => call(`/beta/contracts/${id}`);
export const updateContract = ({ id, ...payload }) =>
	call(`/beta/contracts/${id}`, options(payload, 'PUT'));

export const getDeletePreview = ({ id }) =>
	call(`/beta/contracts/${id}/delete-preview`);

export const deleteContractWithOptions = ({ id, workOrderAction, pmScheduleAction }) =>
	call(
		`/beta/contracts/${id}/delete`,
		options({ workOrderAction, pmScheduleAction }, 'DELETE'),
	);

export const deleteContract = (id) =>
	call(`/beta/contracts/${id}`, options(null, 'DELETE'));

export const addAssetToContract = ({ id, assetId, assetIds }) => {
	const ids = assetIds || (assetId ? [assetId] : []);
	const queryString = ids.map((id) => `assetIds=${id}`).join('&');
	return call(`/beta/contracts/${id}/addAsset?${queryString}`, options(null, 'PUT'));
};

export const removeAssetFromContract = ({ id, assetId }) =>
	call(
		`/beta/contracts/${id}/removeAsset?assetId=${assetId}`,
		options(null, 'PUT')
	);

export const uploadDocumentsToContract = ({ id, ...payload }) =>
	call(`/beta/contracts/${id}/documents`, options(payload, 'POST'));

export const addDocumentToContract = ({ id, documentId, setActivePreview }) =>
	call(
		`/beta/contracts/${id}/documents`,
		options({ documentId, setActivePreview }, 'PUT')
	);

export const removeDocumentFromContract = ({ id, documentId }) =>
	call(`/beta/contracts/${id}/document/${documentId}`, options(null, 'DELETE'));

export const createSingleContractData = ({ id, ...payload }) =>
	call(`/beta/contracts/${id}/data`, options(payload, 'POST'));

export const updateSingleContractData = ({ id, attributeId, ...payload }) =>
	call(`/beta/contracts/${id}/data/${attributeId}`, options(payload, 'PUT'));

export const deleteSingleContractData = ({ id, attributeId, ...payload }) =>
	call(`/beta/contracts/${id}/data/${attributeId}`, options(payload, 'DELETE'));
